import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, Col, Row, Image } from "antd";
import { useTranslation } from "react-i18next";
import avatar from "../../../assets/images/avartar.png";
// import UserStatus from "../../../store/status/userStatus";

const ModalInfomation = ({ showModal, handleClodeModal, infomationUser }) => {
  const { t } = useTranslation();
  const UserStatus = [
    { value: 0, label: t("blocked") },
    { value: 1, label: t("active") },
  ];
  return (
    <>
      <Modal
        forceRender={true}
        title={t("appyInfor")}
        width={600}
        open={showModal}
        toggle={handleClodeModal}
        onCancel={handleClodeModal}
        centered={true}
        footer={null}
      >
        <Row gutter={16}>
          <Col span={24} className="text-center mb-3">
            <Image
              className="rounded-circle"
              height={100}
              width={100}
              preview={false}
              src={
                infomationUser.avatar
                  ? `${process.env.REACT_APP_API_URL}/uploads/images/${infomationUser.avatar}`
                  : avatar
              }
              fallback={avatar}
            />
          </Col>
          <Col span={12}>
            <div className="form-group mb-2">
              <label>{t("fullName")}</label>
              <input
                value={infomationUser.fullName || ""}
                readOnly
                type="text"
                className="form-control"
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group mb-2">
              <label>{t("userName")}</label>
              <input
                value={infomationUser.username || ""}
                readOnly
                type="text"
                className="form-control"
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group mb-2">
              <label>{t("email")}</label>
              <input
                value={infomationUser.email || ""}
                readOnly
                type="text"
                className="form-control"
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group mb-2">
              <label>{t("phone")}</label>
              <input
                value={infomationUser.phoneNumber || ""}
                readOnly
                type="text"
                className="form-control"
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group mb-2">
              <label>{t("activeStatus")}</label>
              {UserStatus.map((item, key) => {
                if (item.value === infomationUser.status) {
                  return (
                    <input
                      key={item.value}
                      value={item.label}
                      readOnly
                      type="text"
                      className="form-control"
                    />
                  );
                }
              })}
            </div>
          </Col>
          <Col span={12}>
            <div className="form-group mb-2">
              <label>{t("cv")}</label>
              <div className="mt-3">
                <a
                  href={`${process.env.REACT_APP_API_URL}/uploads/cv/${infomationUser.cv}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {infomationUser.cv}
                </a>
              </div>
            </div>
          </Col>
          {(window.location.pathname === "/duplicate-ip" ||
            window.location.pathname === "/duplicate-fp" ||
            window.location.pathname === "/duplicate-fp" ||
            window.location.pathname === "/duplicate-ip-fp" ||
            window.location.pathname === "/duplicate-fp-old") && (
            <>
              <Col span={12}>
                <div className="form-group mb-2">
                  <label>{t("company")}</label>
                  <div className="mt-3">
                    <input
                      value={infomationUser.company || ""}
                      readOnly
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div className="form-group mb-2">
                  <label>{t("department")}</label>
                  <div className="mt-3">
                    <input
                      value={infomationUser.department || ""}
                      readOnly
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div className="form-group mb-2">
                  <label>{t("group")}</label>
                  <div className="mt-3">
                    <input
                      value={infomationUser.group || ""}
                      readOnly
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              </Col>
            </>
          )}
        </Row>
        <Row gutter={16} className="mt-3">
          <Col span={24} className="text-center">
            <Button type="danger" onClick={handleClodeModal}>
              {t("close")}
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

ModalInfomation.propTypes = {
  handleClodeModal: PropTypes.func,
  showModal: PropTypes.bool,
  infomationUser: PropTypes.any,
};
export default ModalInfomation;
